import React, { Component } from 'react'
import {TextField, CheckboxField, BoxDouble, RadioField} from 'src/jbc-front/components/Form'
import styles from './TaxIncomeSection.scss'
import {isPercentage, isNumber, minLength4} from 'src/utils/CustomValidators'
import {withTranslation} from "react-i18next"
import { change } from "redux-form"
import { connect } from 'react-redux'
import { CLIENT_FORM } from 'src/constants/FormNames';
import { Section } from 'jbc-front/components/Form';
import {booleanOptions} from 'src/reducers/selectOptions'

class TaxReductionSection extends Component {
    state = {
        Percentage : false
    }

    componentDidMount(){
        const {clientTaxIncome} = this.props
        this.setState({
            Percentage: clientTaxIncome !== null ? clientTaxIncome.isMaxPercentage : false
        })
    }

    componentDidUpdate(prevProps){
        const {clientTaxIncome, dispatch} = this.props
        if(clientTaxIncome && prevProps.clientTaxIncome && prevProps.clientTaxIncome.isMaxPercentage !== clientTaxIncome.isMaxPercentage){
            if(clientTaxIncome.isMaxPercentage !== null){
                this.setState({
                    Percentage: clientTaxIncome.isMaxPercentage
                })
                if(clientTaxIncome.isMaxPercentage === false){
                    dispatch(change(CLIENT_FORM ,"clientTaxIncome.providentFundMaxPercentage",null))
                }
            }
        }
    }

    render() {
        const {Percentage} = this.state
        const { t } = this.props
        return (
            <div>
                <Section title={t('features.Clients.components.TaxIncome.Expense_deduction')}>
                    {/* <BoxDouble> */}
                        <TextField validate={minLength4 && isNumber} name="employeeIncomeDeductionAmount" label={t('features.Clients.components.TaxIncome.Expense_deduction_amount')}/>
                        {/* <TextField validate={isNumber && isPercentage} name="employeeIncomeReductionPercentage" label="Max amount (Percentage)" /> */}
                        {/* <CheckboxField name="isMaxPercentage" label={t('features.Clients.components.TaxIncome.Limit_by_income')} /> */}
                    {/* </BoxDouble> */}
                </Section>
                <Section title={t('features.Clients.components.TaxIncome.Tax_deduction')}>
                    <BoxDouble>
                        <TextField validate={isNumber} name="employeeTaxDeductionAmount" label={t('features.Clients.components.TaxIncome.Employee_tax_deduction_amount')} />
                        <TextField validate={isNumber, isPercentage} name="employeeTaxDeductionPercentage" label={t('features.Clients.components.TaxIncome.Employee_tax_deduction_percentage')} />
                    </BoxDouble>
                    <RadioField name="ssoTaxDeduction" label={t('features.Clients.components.TaxIncome.Sso_tax_reduction')} options={booleanOptions(t('features.Clients.components.TaxIncome.Enable'), t('features.Clients.components.TaxIncome.Disable'))}/>
                    {/* เราจะเจอกันเมื่อถึงเวลานะ */}
                    {/* <div className={styles.flex}>
                        <TextField validate={isNumber && minLength4} name="providentFundTaxReduction" label={t('features.Clients.components.TaxIncome.Provident_fund_tax_reduction')} />
                        <TextField validate={isNumber && isPercentage} disabled={!Percentage} name="providentFundMaxPercentage" label={t('features.Clients.components.TaxIncome.Max_provident_fund_income_percentage')} />
                        <CheckboxField name="isMaxPercentage" label={t('features.Clients.components.TaxIncome.Limit_by_income')} />
                    </div> */}
                </Section>
            </div>
        )
    }
}


export default connect()(withTranslation()(TaxReductionSection))
